import React from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  // Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  PersonAddAlt1 as PersonAddAlt1Icon,
  // Login as LoginIcon,
  Logout as LogoutIcon,
  Map as MapIcon,
  Dashboard as DashboardIcon,
} from "@mui/icons-material";
import UserMenuButton from "../UserMenuButton/UserMenuButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeUserData } from "../../store/slices/userData";
import { locStor } from "../../services/localStorageManipulation";
import { USER_APIKEY } from "../../services/constants";
// import { getRootUrl } from "../../services/urlManipulation";

const drawerWidth = 300;

const Navbar = ({ currentPage, changePage, displayPersonForm }) => {
  const [isMenuOpen, setMenuOpen] = React.useState(false);
  const navigateTo = useNavigate();
  
	const location = useLocation()
  const menu = {
    open: () => {
      setMenuOpen(true);
    },
    close: () => {
      setMenuOpen(false);
    },
  };

  const dispatch = useDispatch();

  const goMap = () => {
    menu.close();
    changePage("Dashboard - Map");
    navigateTo("/map");
  };
  const goDashboard = () => {
    menu.close();
    changePage("Dashboard");
    navigateTo("/dashboard");
  };
  const logoutHandler = () => {
    menu.close();
    changePage("Access");
    dispatch(removeUserData());
    locStor.delete(USER_APIKEY);
    navigateTo("/access");
  };
  const displayPersonFormHandler = (displayPersonFormParam) => {
    menu.close();
    if(location.pathname === "/dashboard"){
      displayPersonForm(displayPersonFormParam);
    }
    else{
      changePage("Dashboard");
      navigateTo("/dashboard");
      setTimeout(()=>{
        displayPersonForm(displayPersonFormParam);
      }, 500)
    }
  };

  const userData = useSelector((state) => state.userData.data);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => {
              if (isMenuOpen) {
                menu.close();
              } else {
                menu.open();
              }
            }}
          >
            {!isMenuOpen && <MenuIcon />}
            {isMenuOpen && <CloseIcon />}
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {currentPage}
          </Typography>
          {userData !== null ? (
            <UserMenuButton logoutFunct={logoutHandler} userData={userData} />
          ) : (
            <Typography variant="h4" component="h1">
              Censo 2023
            </Typography>
          )}
        </Toolbar>
      </AppBar>

      <Toolbar id="top" />
      <Drawer
        open={isMenuOpen}
        onClose={() => {
          setMenuOpen(false);
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Box
          sx={{
            height: "100%",
          }}
        >
          <List
            sx={{
              height: "100%",
            }}
          >
            {userData === null && (
              <p>Ingresa para poder descubrir todas las opciones</p>
            )}
            {userData !== null && (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      displayPersonFormHandler(true);
                    }}
                  >
                    <ListItemIcon>
                      <PersonAddAlt1Icon />
                    </ListItemIcon>
                    <ListItemText primary={"Registrar Persona"} />
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      goDashboard();
                    }}
                  >
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Dashboard"} />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={goMap}>
                    <ListItemIcon>
                      <MapIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Mapa"} />
                  </ListItemButton>
                </ListItem>
                
                <ListItem
                  disablePadding
                  sx={{ bottom: 0, position: "absolute", backgroundColor: "#68bcbc" }}
                >
                  <ListItemButton onClick={logoutHandler}>
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText primary={"Logout"} />
                  </ListItemButton>
                </ListItem>
              </>
            )}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Navbar;
